import { css } from "@emotion/react";
import { ImageProfileBg } from "constants/config";
import { media } from "styles/breakpoints";

export const PrivacyStyle = {
  index: css`
    line-height: 24px;
    background: url(${ImageProfileBg}) top center repeat;
    background-size: 100%;
    padding: 48px 80px;
    ${media.lg} {
      padding: 12px;
    }
    ${media.md} {
      padding: 0 0 10px 0;
    }
    h1 {
      margin-bottom: 40px;
      text-align: center;
    }
    h2 {
      margin-top: 24px;
      margin-bottom: 12px;
    }
    ul,
    ol {
      margin-left: 28px;
    }
    h3 {
      margin-left: 12px;
      margin-top: 8px;
      margin-bottom: 4px;
    }
  `
};
